import {Translations} from './message.def';

export const zh: Translations = {
  privacy: {
    title: '隐私政策',
    acquisition: {
      title: '■ 用户信息的取得',
      text: '本应用需要获取用户定位和追踪信息以实现日志功能。',
    },
    use: {
      title: '■ 用户信息的使用',
      text: '本应用使用获取的用户定位和追踪信息用于日志的阅览功能。',
    },
    disclosure: {
      title: '■ 关于向第三方提供用户信息',
      text: '本应用不会向任何第三方提供用户个人信息。',
    },
    tools: {
      title: '■ 广告投放工具',
      text: '本应用使用AppLovin（AppLovin Corporation）作为广告投放工具，AppLovin可能会自动收集用户信息。有关收集的信息、使用目的以及向第三方披露的详细信息，请参阅广告投放运营商的应用隐私政策。\n（本应用已设置为不允许AppLovin收集用户信息。）',
    },
    contact: {
      title: '■ 联系方式',
      text: '如果您有任何疑问或问题，请通过以下邮件地址与我们联系。\ndev.logme@gmail.com',
    },
  },
};
